import React from "react";

export const ExplanationPyramidIt = () => {
  return (
    <>

      <h1 className="text-2xl font-bold text-gray-900 mb-4 mt-4">Come Funziona uno Schema Piramidale</h1>
      <h3 className="mt-2"><strong>Passo 1: Lo Schema è Creato</strong></h3>
      <ul>
        <li>Un fondatore o leader avvia lo schema e lo presenta come un'opportunità di investimento o di affari.</li>
        <li>Ai partecipanti vengono promessi alti rendimenti per reclutare altri piuttosto che vendere un prodotto o servizio.</li>
      </ul>
      <h3 className="mt-2"><strong>Passo 2: I Primi Partecipanti Si Uniscono</strong></h3>
      <ul>
        <li>I primi reclutati investono denaro per entrare nello schema.</li>
        <li>Il loro denaro va al fondatore o ai membri di livello superiore.</li>
        <li>Viene poi detto loro di reclutare altri per guadagnare rendimenti.</li>
      </ul>
      <h3 className="mt-2"><strong>Passo 3: Crescita Attraverso il Reclutamento</strong></h3>
      <ul>
        <li>I nuovi reclutati devono pagare per entrare, e il loro denaro viene utilizzato per pagare i membri precedenti.</li>
        <li>Lo schema cresce esponenzialmente, richiedendo sempre più reclutati a ogni livello.</li>
      </ul>

      <h3 className="mt-2"><strong>Passo 4: L'Insostenibilità Diventa Evidente</strong></h3>
      <ul>
        <li>Alla fine, il numero di nuovi reclutati rallenta, ma lo schema richiede una crescita continua.</li>
        <li>I livelli inferiori faticano a reclutare, il che significa che la maggior parte dei partecipanti perde il proprio denaro.</li>
      </ul>
      <h3 className="mt-2"><strong>Passo 5: Il Collasso</strong></h3>
      <ul>
        <li>Una volta che il reclutamento si ferma, il flusso di cassa si esaurisce.</li>
        <li>Quelli ai livelli inferiori perdono il loro investimento, e lo schema crolla.</li>
        <li>Gli organizzatori principali possono scomparire con i fondi rimanenti, oppure le autorità possono intervenire.</li>
      </ul>
      <h3 className="mt-2"><strong>Segnali Chiave di uno Schema Piramidale</strong></h3>
      <ul>
        <li>1. Enfasi sul reclutamento piuttosto che sulla vendita di un vero prodotto o servizio.</li>
        <li>2. Alte commissioni di investimento iniziali con promesse di grandi rendimenti.</li>
        <li>3. Crescita matematicamente insostenibile—alla fine non ci sono abbastanza nuove persone da reclutare.</li>
        <li>4. La maggior parte dei partecipanti perde denaro, con benefici solo per i membri di alto livello.</li>
      </ul>
    </>
  );
};
